import React, { useCallback, memo } from 'react';
import { FormGroup, FormToggle } from '../../common/form';
import { BetaBadge } from '../../common/Badges';

import styles from '../styles/AgentSettings.module.css';

const AgentMemoryTab = ({ data = {}, onChange }) => {
    const handleToggle = useCallback((field, value) => {
        onChange?.({ [field]: value });
    }, [onChange]);

    return (
        <div className={styles.tabContent}>
            <div className={styles.section}>
                <div className={styles.sectionHeader}>
                    <h3 className={styles.sectionTitle} style={{ margin: '0' }}>Memory</h3>
                    <BetaBadge />
                </div>
                <p className={styles.sectionDescription}>
                    If memory is disabled here, it will not be used in dialogs. Each user can also disable agent memory in their own settings.
                </p>

                <FormGroup>
                    <FormToggle
                        checked={!!data.memoryEnabled}
                        onChange={value => handleToggle('memoryEnabled', value)}
                        title="Enable Agent Memory"
                        description="Use stored facts about the user, past interactions, and context."
                    />
                </FormGroup>
            </div>
        </div>
    );
};

export default memo(AgentMemoryTab);
